import React, { ComponentPropsWithoutRef, ReactNode } from "react";

import { ErrorText } from "~/ui/common/ErrorText";
import { tw } from "~/utils";

interface CheckBoxProps extends ComponentPropsWithoutRef<"input"> {
  id: string;
  children?: ReactNode;
  labelClassName?: string;
  error?: string;
  className?: string;
  containerClassName?: string;
  parentClassName?: string;
}

const CheckBox = React.forwardRef<HTMLInputElement, CheckBoxProps>(
  (
    {
      className,
      children,
      id,
      labelClassName,
      containerClassName,
      parentClassName,
      error,
      ...props
    }: CheckBoxProps,
    ref,
  ) => {
    const errorId = `${id}-error`;
    return (
      <div
        className={tw(
          "flex w-full flex-col gap-1 px-1 text-gray-700",
          parentClassName,
        )}
      >
        <div
          className={tw("flex w-full items-center gap-2", containerClassName)}
        >
          <input
            className={tw(
              "size-4 cursor-pointer rounded-md border-neutral-700 bg-slate-50",
              "checked:bg-primary-600 checked:hover:bg-primary-600",
              "focus:checked:bg-primary-600",
              className,
            )}
            id={id}
            {...props}
            ref={ref}
            type="checkbox"
            required={props.required}
            aria-describedby={errorId}
            aria-invalid={!!error}
          />
          {children && (
            <label
              htmlFor={id}
              className={tw(
                "cursor-pointer first-letter:uppercase",
                labelClassName,
              )}
            >
              {children}
            </label>
          )}
        </div>
        {error && <ErrorText id={errorId}>{error}</ErrorText>}
      </div>
    );
  },
);

export default CheckBox;
